export const getFormattedSortCode = (sortCode?: string | null): string => {
  if (!sortCode) return '-';
  const digits = sortCode.replace(/\D/g, '');
  if (!digits) return '-';
  return digits.replace(/(\d{2})(?=\d)/g, '$1-');
};
